import React, { useState } from 'react';
import { Form } from '@ant-design/compatible';
import { WrappedFormUtils } from '@ant-design/compatible/lib/form/Form';

import MainCategoryInfo from './MainCategoryInfo';
import ModifyHistory from './ModifyHistory';
import ButtonList from './ButtonList';
import useCategoryHistory from './useCategoryHistory';
import useCategoryUpdateModal from '../../../../hooks/category/useCategoryUpdateModal';
import { Category } from '../types';

interface IMainCategoryDetailProps {
  form: WrappedFormUtils;
  category: Category;
}
const MainCategoryDetail = (props: IMainCategoryDetailProps) => {
  const { form, category } = props;
  const [isEditable, setIsEditable] = useState(false);

  const { data: firstHistory } = useCategoryHistory({
    type: 'first',
  });
  const { data: lastHistory } = useCategoryHistory({
    type: 'last',
  });

  // 카테고리 수정 저장 및 취소 버튼을 눌렀을 때 콜백 함수
  const { onClickSaveConfirmBtn, onClickCancelConfirmBtn } = useCategoryUpdateModal(form, setIsEditable);

  return (
    <>
      <div className="main-title">1차 카테고리 정보</div>
      <MainCategoryInfo form={form} isEditable={isEditable} category={category} />
      <div className="main-title">수정 이력</div>
      <ModifyHistory
        firstCreateName={firstHistory?.name}
        firstCreateDate={firstHistory?.date}
        lastUpdateName={lastHistory?.name}
        lastUpdateDate={lastHistory?.date}
      />
      <ButtonList
        isEditable={isEditable}
        onClickEditBtn={() => setIsEditable(true)}
        onClickSaveConfirmBtn={onClickSaveConfirmBtn}
        onClickCancelConfirmBtn={onClickCancelConfirmBtn}
      />
    </>
  );
};

export default Form.create()(MainCategoryDetail);
